import { mapGetters } from 'vuex';

const mixin = {
  computed: mapGetters({
    user: 'user/user/user',
  }),
  methods: {
    isAuth() {
      return this.user.authenticated;
    },
    isLandlord() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.user.data.selectedRole.role === 'landlord';
      } else {
        return false;
      }
    },
    isTenant() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.user.data.selectedRole.role === 'tenant';
      } else {
        return false;
      }
    },
    isUser() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.user.data.selectedRole.role === 'user';
      } else {
        return false;
      }
    },
    isSuperAdmin() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.user.data.selectedRole.isSuperadmin
          ? this.user.data.selectedRole.isSuperadmin
          : false;
      } else {
        return false;
      }
    },
    canChangeGuestParkingPrice() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.user.data.selectedRole.isSuperadmin
          ? this.user.data.selectedRole.isSuperadmin
          : this.user.data.selectedRole.canChangeGuestParkingPrice
            ? this.user.data.selectedRole.canChangeGuestParkingPrice
            : false;
      } else {
        return false;
      }
    },
    hasPricingRules() {
      return this.user.hasPricingRules;
    },
    hasPermitPacks() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.isTenant() && this.user.data.selectedRole.permitPack;
      } else {
        return false;
      }
    },
    hasGuestParking() {
      if(this.user.data.selectedRole && this.user.data.selectedRole.role) {
        return this.isTenant() && this.user.data.selectedRole.guestParking;
      } else {
        return false;
      }
    },
    isAutloIntegrationEnabled() {
      return process.env.AUTLO_INTEGRATION_ENABLED;
    },
    isJSON(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  },
};

export default {
  install(Vue) {
    Vue.mixin(mixin);
  },
};



// WEBPACK FOOTER //
// ./src/helpers.js